module.exports = __webpack_public_path__ + "img/sarah_rabe_7.892c2384.jpg";